import styled, { css } from 'styled-components';

export const WrapperTrucker = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km3};

    > fuel-skeleton {
      flex-shrink: 0;
    }
  `}
`;
